<style scoped lang="scss">
@import "@/assets/scss/global.scss";

.glaze-h1 {
    font-size: 24px;
    font-weight: 300;
    z-index: 2;
    letter-spacing: .96px;
    min-width: 323px;
    color: #022266;
    line-height: 48px;
    font-size: 32px;
}

.title-bar {
    max-width: 1032px;
    margin-left: auto;
    margin-right: auto;

    font-size: 24pt;
    font-weight: 300;
    line-height: 47px;
    z-index: 2;
    letter-spacing: 0.96px;
    min-width: 323px;
    color: $glaze-blue;

    @media (max-width: 323px) {
        min-width: 296px;
        font-size: 36px;
    }
}

.header-background {
    border-top: 1px solid #e7e7e7;
    background-color: #fafafa;
    padding-top: 42px;
    padding-bottom: 42px;
    border-bottom: 1px solid #e7e7e7;
}

.glaze-content-wrapper {
    max-width: 1032px;
    margin-left: auto;
    margin-right: auto;
}

.tou-content-wrapper {
    max-width: 1032px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 32px;
    position: relative;
    font-size: 14px;
    color: #000;
    letter-spacing: 0;
    line-height: 24px;
}

.marketplace-title {
    opacity: .87;
    font-size: 16px;
    color: #000;
    letter-spacing: 0;
    line-height: 24px;
}

.marketplace-subtitle {
    font-size: 14px;
    color: #000;
    letter-spacing: 0;
    line-height: 24px;
}

.separator-50 {
    height: 50px;
}
</style>

<template>
    <div class="terms-wrapper">
        <div class="header-background">
            <v-layout class="title-bar" row>
                <v-flex class="glaze-h1">
                    Terms of Use
                </v-flex>
            </v-layout>
        </div>
        <div data-v-52ad5c5c="" class="tou-content-wrapper"><span class="marketplace-title">Marketplace Terms of
                Use</span><br><br><span class="marketplace-subtitle">Effective Date: April 14,
                2019 </span><br><br><span class="marketplace-subtitle">YOUR ACCEPTANCE</span><br>
            Please read these Terms of Use (the “Terms”) carefully because this document is legally binding on you
            even if you <br>
            are just browsing Glazestock.com (the “Site”) without creating an account or contacting us. The term
            "us," "we" or <br>
            "our" refers to Wavy Corporation which owns and operates of this Site. The term "you" refers to the
            viewer of the <br>
            Site. Our Privacy Policy also governs your use of the Site. If you do not want to accept and agree to
            these Terms or <br>
            the Privacy Policy, you must exit the Site. Note that we may revise these Terms every once in a while
            whenever we <br>
            feel it is appropriate, without notifying you. If you continue visiting our Site after we have published
            the revised <br>
            Terms on this page, this constitutes your acceptance of the changes. So, please check this page
            periodically to <br>
            take notice of any changes we made. <br><br><span class="marketplace-subtitle">PLATFORM
                DESCRIPTION</span><br>
            Neutral Venue. Our Site is a marketplace where creators of digital content can license it to other Site
            users. OUR <br>
            SITE IS A NEUTRAL VENUE to match licensors and licensees. WE DISCLAIM ALL LIABILITY ARISING OUT OF OR
            <br>
            RELATED TO CONTENT AND INFORMATION PROVIDED TO OR BY THE SITE USERS. All ownership rights in the digital
            <br>
            content remain with the owner; licensee is just purchasing a license (right to use) said piece of
            content. We do not <br>
            endorse any Site user (be it licensor, licensee or any other Site visitor). <br>
            User Accounts. Users can upload and/or purchase license to content by creating accounts. They can use a
            Google <br>
            ID or Facebook to login. Users must keep their login credential confidential. You may be liable for
            damages caused <br>
            by unauthorized use of your account. <br>
            Third Party Services. The Site may contain links to third party websites/services that are not owned or
            controlled by <br>
            us. For example, our payment processors. We assume no responsibility for, the content, privacy policies,
            or <br>
            practices of any third party websites. In addition, the Site will not and cannot censor or edit the
            content of any <br>
            third-party website. You acknowledge that we will not be liable for any and all claims, demands and
            damages of any <br>
            kind and nature arising out of or in any way connected from any and all potential liabilities arising
            from the use of <br>
            any third-party website. We cannot guarantee the availability or performance of any third party services
            used to <br>
            support the Site. Such third party services may change their operations without notice to us. Therefore,
            we shall <br>
            not be liable for any outages, version changes, delivery delays, failures, bugs, or termination of third
            party network <br>
            service. Third party networks have their own terms of use, and you must comply with any Terms and
            Conditions <br>
            provided by any third party network.<br><br><span class="marketplace-subtitle">INTELLECTUAL
                PROPERTY</span><br>
            Our IP. All Site registered and unregistered trademarks, designs, information, look and feel (the
            “Intellectual <br>
            Property”) belong to us and our content suppliers. The Intellectual Property is protected by U.S. and
            international <br>
            trademark, copyright, privacy, and other intellectual property laws. You obtain no interest in our
            Intellectual <br>
            Property. All rights not expressly granted under these Terms are reserved by us. Unless expressly stated
            <br>
            otherwise, you shall not copy, reproduce or replicate any Intellectual Property. We have the right but
            not the <br>
            obligation to monitor and edit or remove any content submitted by users. We take no responsibility and
            assume no <br>
            liability for any content posted by users or any third party; we do not guarantee that user content does
            not infringe <br>
            third party intellectual property rights. <br>
            Your Content. What’s your remains yours. By listing your content on our Site, you agree to grant a buyer
            a license to <br>
            use your content upon payment. By uploading any content to our Site, you represent and warrant that you
            have the <br>
            right, title, and/or authority to grant such license. <br>
            License. When you purchase a license to a piece of content from the Site, you get a non-exclusive
            license to use <br>
            that piece of content under the terms spelled out in the license. Author remains the owner of the item
            and can also <br>
            license that same content to others. <br>
            Copyright Infringement Claims. Unauthorized copying, distribution, modification, public display, or
            public <br>
            performance of copyrighted works is an infringement of the copyright holder’s rights. You agree that you
            will not <br>
            use our Site to infringe anyone’s intellectual property rights. We will investigate copyright
            infringement claims if <br>
            they are reported to us to support@glazestock.com <br><br><span class="marketplace-subtitle">YOUR
                OBLIGATIONS</span><br>
            By using this Site, you represent, warrant and agree that: <br>
            If you place an order, you have a full capacity to form a legally binding contract. <br>
            You will provide a valid payment method information when necessary and pay all sums due when due. You
            will not <br>
            use payment methods which you are not authorized to use. You will not use fake identity. <br>
            You will not use licensed content in any pornographic, defamatory, or unlawful manner. <br>
            If you download a preview file from the Site, you will not remove any watermarking or other protective
            measures <br>
            from the preview file. You can only use the preview file for evaluation purposes. <br>
            You will not create duplicate accounts and you will not share your account with anyone. You are solely
            responsible <br>
            for all activity that occurs under your account. <br>
            Our Site may contain typographical errors, “price bugs” (mispriced items) or other inaccuracies. <br>
            Submission of untruthful posts, articles or other content may result in account termination. We may
            reject or erase <br>
            or edit any content submitted for any reason without prior notice to you, within our sole reasonable
            discretion. All <br>
            content you submit to our Site is free of third party intellectual property claims and contains no
            vulgar, profane, <br>
            defamatory, abusive, racist or hateful language or expressions. You will only submit true, complete and
            not <br>
            misleading information to the Site. <br>
            Our Site content may not be copied for republication, either online or on paper, without our prior
            express written <br>
            permission. <br>
            You will not submit unsolicited bulk or commercial messages ("spam") to our Site, other users or anyone
            else. Any <br>
            unsolicited message must also not direct the recipient to any third party site or other resource. <br>
            You will only use the Site for legal purposes and you will remain responsible for complying with all
            laws applicable <br>
            to your use of the Site. <br>
            All persons who access the Site through your Internet connection (i) will have a legal right to do so,
            and (ii) will read <br>
            and comply with these Terms of Use. <br>
            We have the right to refuse access, service or disable your account on our Site at any time for any
            reason or no <br>
            reason without notice, explanation or liability of any kind. <br>
            You may not use any web spiders, bots, indexers, robots, crawlers, harvesters, or any other automatic
            process to <br>
            access, acquire, copy or monitor any portion of the Site or any content, or in any way reproduce or
            circumvent the <br>
            navigational structure or presentation of the Site or any content. <br>
            You will not interfere with the proper working of the Site. You will not impersonate any other person or
            entity, <br>
            submit any false, defamatory, offensive, harassing material, or any material that infringes or violates
            another <br>
            party's intellectual property rights and rights of privacy and publicity. <br><br><span
                class="marketplace-subtitle">REMEDIES FOR BREACH OF
                THESE TERMS</span><br>
            We may take any action that we deem necessary or appropriate if we believe that any user violates the
            Terms of <br>
            Use, infringes any intellectual property right, privacy right or confidentiality principles, threatens
            anybody’s <br>
            personal safety or uses offensive language. We may: (i) disclose user’s identity to law enforcement
            agencies, to <br>
            any third party claiming violation of their intellectual property or privacy right, (ii) block user’s IP
            address, notify <br>
            user’s Internet Service Provider, suspend or terminate any account on our Site, (iii) moderate any
            content <br>
            submitted to us, (iv) take any other action provided for in these Terms of Use or available under equity
            or law. <br>
            Since we cannot ensure that all material submitted to us is accurate and free of third party claims, we
            assume no <br>
            liability for any action or inaction regarding transmissions, communications or content provided by any
            user or <br>
            third party. <br><br><span class="marketplace-subtitle">DISCLAIMER OF WARRANTY; LIMITATION OF
                LIABILITY</span><br>
            USE OF OUR SITE AND CONTENTS LICENSED FROM IT IS AT YOUR OWN RISK. THIS SITE AND ALL OF ITS CONTENT ARE
            <br>
            PROVIDED "AS IS". WE DO NOT MAKE, AND EXPRESSLY DISCLAIM, ANY REPRESENTATIONS, WARRANTIES, COVENANTS <br>
            AND CONDITIONS, EXPRESS OR IMPLIED, ARISING OUT OF OPERATION OF LAW, COURSE OF PERFORMANCE, COURSE <br>
            OF DEALING, USAGE OF TRADE OR OTHERWISE, INCLUDING ANY EXPRESS OR IMPLIED WARRANTIES AND CONDITIONS <br>
            OF: MERCHANTABILITY; FITNESS FOR A PARTICULAR PURPOSE; NON-INFRINGEMENT; SAFETY; QUALITY; FREEDOM <br>
            FROM DEFECTS OR THAT DEFECTS WILL BE CORRECTED; UNINTERRUPTED, VIRUS-FREE OR ERROR-FREE USE OF THIS <br>
            SITE; OR ACCURACY, CURRENCY, RELIABILITY, COMPLETENESS OR APPROPRIATENESS RELATING TO THE CONTENT OF <br>
            THIS SITE. <br>
            WE SHALL NOT BE LIABLE TO YOU FOR INDIRECT, INCIDENTAL, SPECIAL OR CONSEQUENTIAL DAMAGES, INCLUDING <br>
            LOST PROFITS AND PROPERTY DAMAGE, EVEN IF WE WERE ADVISED OF THE POSSIBILITY OF SUCH DAMAGES, NOR <br>
            SHALL WE BE HELD LIABLE FOR DELAY OR FAILURE IN PERFORMANCE RESULTING FROM CAUSES BEYOND OUR <br>
            REASONABLE CONTROL. IN NO EVENT SHALL OUR TOTAL LIABILITY TO YOU FOR ALL DAMAGES, LOSSES AND CAUSES <br>
            OF ACTION EXCEED THE PRICE YOU PAID FOR THE PROBLEMATIC PIECE OF CONTENT. NO CLAIM, SUIT OR ACTION MAY
            <br>
            BE BROUGHT AGAINST US AFTER SIX MONTHS FROM THE UNDERLYING CAUSE OF ACTION. SOME JURISDICTIONS DO <br>
            NOT ALLOW THE EXCLUSION OF CERTAIN WARRANTIES OR THE LIMITATION, OR EXCLUSION OF LIABILITY FOR <br>
            INCIDENTAL OR CONSEQUENTIAL DAMAGES, SO THE ABOVE LIMITATIONS MAY NOT APPLY TO YOU. <br><br><span
                class="marketplace-subtitle">INDEMNIFICATION</span><br>
            You agree to defend, indemnify and hold harmless our company, its officers, directors, employees and
            agents, <br>
            from and against any and all claims, damages, obligations, losses, liabilities, costs or debt, and
            expenses (including <br>
            but not limited to attorney's fees) arising from: (i) your use of the Site and content provided to it or
            obtained from <br>
            it; (ii) your violation of any provision of these Terms; (iii) your violation of any third party right,
            including without <br>
            limitation any copyright, property, or privacy right; or (iv) any claim that any of your user
            submissions caused <br>
            damage to a third party. <br><br><span class="marketplace-subtitle">GOVERNING LAW</span><br>
            These Terms and any action related thereto will be governed by the laws of California, without regard to
            its conflict <br>
            of laws provisions that would result in application of any other law. You consent to the exclusive
            jurisdiction and <br>
            venue of the courts located in Los Angeles, CA in connection with any matter based upon or arising out
            of these <br>
            Terms or the matters contemplated herein. <br><br><span class="marketplace-subtitle">GENERAL</span><br>
            Electronic Communications. You agree that all notices or other communications regarding your account
            and/or <br>
            your use of the Site ("Communications"), may be provided to you electronically and you agree to receive
            all <br>
            Communications from us in electronic form. You may print a copy of any Communications and retain it for
            your <br>
            records. All electronic Communications will be considered just as legally binding as if they were in
            paper form. You <br>
            may revoke your consent to receive Communications electronically, but if you revoke your consent to
            receive <br>
            Communications electronically, we reserve the right to terminate your right to use our Site. <br>
            Hyperlinks. You may link to our Site, as long as this is done in a fair way that does not negatively
            affect our <br>
            reputation or business and does not suggest any form of association where there is none. You cannot
            frame our <br>
            Site on any other website. We reserve the right to request that you withdraw any link and you agree to
            cooperate <br>
            with us in causing any unauthorized framing or linking to terminate immediately. <br>
            Assignment. We may transfer, assign or subcontract the rights, interests or obligations under these
            Terms, at our <br>
            sole discretion, without obtaining your consent. <br>
            Severability. Should any part of these Terms of Use be rendered or declared invalid by an appropriate
            authority, <br>
            such invalidation of such part or portion of these Terms of Use should not invalidate the remaining
            portions <br>
            thereof, and they shall remain in full force and effect. <br>
            No Waiver. Enforcement of these Terms of Use is solely in our discretion, and failure to enforce the
            Terms of Use in <br>
            some instances does not constitute a waiver of our right to enforce them in other instances. <br>
            Prevailing Language. In the event of any discrepancy between the English original version of these Terms
            and any <br>
            foreign language translation, the English version prevails. <br><br><span
                class="marketplace-subtitle">FEEDBACK</span><br>
            Please submit your inquiries to support@glazestock.com <br>
            <div class="separator-50"></div>
        </div>
    </div>

</template>

<script>
export default {
    mounted: function () {
    },
    data() {
        return {};
    }
    // methods: {},
    // watch: {},
    // computed: {},
    // created() {},
    // components: {}
};
</script>
